import routesMap from './routesMap'

export const isAllowed = (type, state) => {
  const role = routesMap[type] && routesMap[type].role // you can put arbitrary keys in routes
  if (!role) return true

  const user = userFromState(state)

  if (!user) return false

  // User found - return true
  return true
  // In case of roles do something like this
  // return user.roles.includes(role)
}

const userFromState = ({ auth: { user: userObj } }) => userObj



// WEBPACK FOOTER //
// ./state/utils.js